/* Shopify policy pages (/policies/*) are plain text from Settings > Policies. For reading:
   short all-caps lines become styled headings, "-----" lines become rules and bare web
   addresses become links. The policy text itself is unchanged in Shopify. */
(() => {
  const body = document.querySelector('.shopify-policy__body .rte, .shopify-policy__body');
  if (!body) return;
  body.querySelectorAll('p, div').forEach((el) => {
    if (el.children.length > 1) return;
    const text = el.textContent.trim();
    if (/^-{3,}$/.test(text)) {
      el.replaceWith(document.createElement('hr'));
    } else if (text.length > 2 && text.length < 90 && /[A-Z]/.test(text) && text === text.toUpperCase() && !/[.!?,]$/.test(text)) {
      el.classList.add('sh-policy-heading');
      el.setAttribute('role', 'heading');
      el.setAttribute('aria-level', '2');
    }
  });
  const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  const urls = [];
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.parentElement.closest('a') || !/(https?:\/\/|www\.)\S+/.test(node.textContent)) continue;
    urls.push(node);
  }
  urls.forEach((node) => {
    const span = document.createElement('span');
    span.innerHTML = node.textContent
      .replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))
      .replace(/((?:https?:\/\/|www\.)[^\s<)]+[^\s<).,;])/g, (url) => `<a href="${url.startsWith('www.') ? 'https://' + url : url}" target="_blank" rel="noopener">${url}</a>`);
    node.replaceWith(...span.childNodes);
  });
})();
